import { CASTypes } from '../../../cimsPage/instances/cas'
import { Types } from '../../common'

const types = Types({
  page: CASTypes,
  create: '053ddb2f-73c8-44e5-959c-f26997b28f06',
  view: 'd15b97f9-c085-4617-9f69-a638650d3a69',
  edit: '61af0c6f-db85-4c9a-ae0d-d347f96e43bc',
  removeRestore: 'a6601c94-f914-4f8b-8a59-f8a52597a3cb',
})

export const CreateCASType = types.Create
export const ViewCASType = types.View
export const EditCASType = types.Edit
export const RemoveRestoreCASType = types.RemoveRestore

export type CASTypePermission =
  | typeof CreateCASType
  | typeof ViewCASType
  | typeof EditCASType
  | typeof RemoveRestoreCASType
